import { createContext } from 'react';
import EditFiservQrSubsidiaryConfigContext from 'types/contexts/EditFiservQrSubsidiaryConfigContext';

export default createContext({} as EditFiservQrSubsidiaryConfigContext);
